import * as yup from 'yup';
import { Integration } from 'store/integrations';
import { validateText } from 'utils/validation';
import { IntegrationForm } from './types';

export const integrationValidationSchema = yup.object().shape({
  name: validateText(),
  code: validateText()
});

/**
 * Generates the form used to create an integration, or to edit the given one.
 */
export const getIntegrationForm = (integration?: Integration): IntegrationForm => {
  const name = integration?.name ?? '';
  const code = integration?.code ?? '';

  return {
    name: {
      error: null,
      initialValue: name,
      propertyPath: 'name',
      readOnly: false,
      shouldParse: false,
      value: name
    },
    code: {
      error: null,
      initialValue: code,
      propertyPath: 'code',
      readOnly: false,
      shouldParse: false,
      value: code
    }
  };
};
